import React, { useState } from 'react';
import './authSignup.css';
import { useNavigate } from 'react-router-dom';
import { signup } from '../../services/authService';
import zxcvbn from 'zxcvbn'; 

function Signup() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [passwordStrength, setPasswordStrength] = useState(null);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  
  const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        setPasswordStrength(zxcvbn(value));
      };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signup({ username, email, password, companyName });
	  setMessage('Signup successful !');
      setTimeout(() => navigate('/login'), 3000);
    } catch (error) {
      setMessage(error.message || 'Signup failed.');
    }
  };

  return (
        <div>
          <form onSubmit={handleSubmit} className="signup-form">
		    <h2 className="signup-header">Get started</h2>
            <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
            />
            <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={handlePasswordChange}
            />
            {passwordStrength && (
                <div>
                    <strong>Password Strength:</strong> {passwordStrength.score}/4
                    <p>{passwordStrength.feedback.warning}</p>
                    {passwordStrength.feedback.suggestions.length > 0 && (
                        <p>Suggestions: {passwordStrength.feedback.suggestions.join('. ')}</p>
                    )}
                </div>
            )}
            <input
                type="text"
                placeholder="Company Name (Optional)"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
            />
            <button type="submit">Signup</button>
        </form>
          {message && <div>{message}</div>}
        </div>
      );
}

export default Signup;